import React from 'react';
import { Link } from 'react-router-dom';
import { LuArrowUpRight } from "react-icons/lu";
import "./ServiceCard.scss";

const ServiceCard = ({ icon, title, description, serviceId }) => {
    return (
        <Link to={`/services#${serviceId}`} className="service-card-link" >
            <div className="service-card">
                {/* Top Icon Section */}
                <div className="service-card-icon-section">
                    <div className="icon-container">{icon}</div>
                </div>

                {/* Bottom Content Section */}
                <div className="service-card-content">
                    <h3 className="service-card-title">{title}</h3>
                    <p className="service-card-description">{description}</p>

                    {/* Button */}
                    <div className="service-card-button">
                        <span>View Service</span>
                        <LuArrowUpRight size={18} aria-hidden="true" />
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default ServiceCard;
